import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ShowPassword = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M8.999 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="m18.88 7.051 3.535 3.535c.78.78.78 2.05 0 2.828L18.88 16.95A7.042 7.042 0 0 1 13.932 19L10.07 19a6.954 6.954 0 0 1-4.95-2.05l-3.536-3.536a2.001 2.001 0 0 1 0-2.828L5.12 7.05A6.95 6.95 0 0 1 10.07 5l3.862.001c1.868 0 3.626.727 4.947 2.05ZM13.93 17a5.029 5.029 0 0 0 3.536-1.464L21.002 12l-3.536-3.534a4.961 4.961 0 0 0-3.534-1.464H10.07a4.967 4.967 0 0 0-3.536 1.463L2.999 12l3.536 3.536A4.971 4.971 0 0 0 10.07 17h3.86Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default ShowPassword;
